export default __webpack_public_path__ + "static/159-66f4195a81d1cfe6afbaeaf7c9013779.jpg";